<div dt-keyboardnavigation cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1"> {{ 'CHANGE_OF' | translate }} {{ whatChanged }} </h1>
        <p class="dt-l-article__section__description">
          {{ 'AGREEMENT_TEXT_1' | translate }} {{ whatChanged }}
          {{ 'AGREEMENT_TEXT_2' | translate }}
        </p>
        <!-- <div classs="dt-l-button-group__vertical"> -->
        <!--
            <button type="button" *ngIf="showTermsOfUse" class="dt-c-button primary orderButtonVertical" (click)="openTermsOfUse()">{{'TERMS_OF_USE' | translate}}</button>
            <button type="button" *ngIf="showPrivacyPolicy" class="dt-c-button primary orderButtonVertical" (click)="openPrivacyPolicy()">{{'PRIVACY_POLICY' | translate}}</button>
            -->
        <div class="dt-l-list" *ngIf="showTermsOfUse || showPrivacyPolicy">
          <div class="dt-l-list__items">
            <a tabindex="0" class="dt-l-list__item" (click)="openTermsOfUse()" *ngIf="showTermsOfUse">
              <span class="dt-l-list__item__content">
                {{ 'TERMS_OF_USE' | translate }}
              </span>
              <span class="dt-l-list__indicator">
                <i aria-hidden="true" class="ui-icon-external-link"></i>
              </span>
            </a>
            <a tabindex="0" class="dt-l-list__item" (click)="openPrivacyPolicy()" *ngIf="showPrivacyPolicy">
              <span class="dt-l-list__item__content">
                {{ 'PRIVACY_POLICY' | translate }}
              </span>
              <span class="dt-l-list__indicator">
                <i aria-hidden="true" class="ui-icon-external-link"></i>
              </span>
            </a>
          </div>
        </div>
        <!-- </div> -->

        <p class="dt-l-article__section__description">
          {{ 'AGREEMENT_TEXT_3' | translate }} {{ whatChanged }}
          {{ 'AGREEMENT_TEXT_4' | translate }}
        </p>

        <div class="dt-l-button-group__vertical">
          <button type="button" class="dt-c-button primary orderButtonVertical" (click)="accept()">
            {{ 'ACCEPT' | translate }}
          </button>
          <div class="dt-l-button-group__separator">
            {{ 'DELETE_ACCOUNT_TEXT' | translate }} {{ 'DELETE_ACCOUNT' | translate }}.
          </div>
          <button type="button" class="dt-c-button danger orderButtonVertical" appDeleteAccount>
            {{ 'DELETE_ACCOUNT' | translate }}
          </button>
        </div>
      </section>
    </div>
  </article>
</div>
